export const HELP_SEARCH_INDEX_URL = "https://forkto.com/help/search-index.json";

let cachedArticles;
let pendingRequest;

function asString(value) {
    return typeof value === "string" ? value.trim() : "";
}

export function parseHelpSearchIndex(payload) {
    if (payload?.version !== 1 || !Array.isArray(payload.articles)) {
        throw new Error("Unsupported help search index");
    }

    const articles = payload.articles.map((article) => ({
        id: asString(article?.id),
        title: asString(article?.title),
        description: asString(article?.description),
        category: asString(article?.category),
        url: asString(article?.url),
        searchText: asString(article?.searchText).toLowerCase()
    }));

    const valid = articles.every(
        (article) =>
            article.id &&
            article.title &&
            article.category &&
            article.url.startsWith("https://forkto.com/help/") &&
            article.searchText
    );
    if (!valid) throw new Error("Invalid help search index");

    return articles;
}

export function loadHelpSearchIndex(fetchImpl = globalThis.fetch) {
    if (cachedArticles) return Promise.resolve(cachedArticles);
    if (pendingRequest) return pendingRequest;
    if (typeof fetchImpl !== "function") return Promise.reject(new Error("Fetch unavailable"));

    pendingRequest = fetchImpl(HELP_SEARCH_INDEX_URL, {
        headers: { Accept: "application/json" },
        cache: "force-cache"
    })
        .then((response) => {
            if (!response.ok) throw new Error(`Help search index returned ${response.status}`);
            return response.json();
        })
        .then((payload) => {
            cachedArticles = parseHelpSearchIndex(payload);
            return cachedArticles;
        })
        .finally(() => {
            pendingRequest = undefined;
        });

    return pendingRequest;
}

export function resetHelpSearchIndexCache() {
    cachedArticles = undefined;
    pendingRequest = undefined;
}
